import { directors, quoteRequests } from './mockData'
import { members } from './adminExtendedData'
import { aiRuns } from './parityData'
import { mockupJobs } from './parityDetailData'
import { moderationCases } from './moderationData'

const RULES = [
  { pattern: /^\/members\/([^/]+)$/, rows: members, entity: '회원', back: '/members' },
  { pattern: /^\/directors\/([^/]+)$/, rows: directors, entity: '디렉터', back: '/directors' },
  { pattern: /^\/quote-requests\/([^/]+)$/, rows: quoteRequests, entity: '견적 요청', back: '/quote-requests' },
  { pattern: /^\/ai\/runs\/([^/]+)$/, rows: aiRuns, entity: 'AI 실행 이력', back: '/ai/runs' },
  { pattern: /^\/ai\/mockup-jobs\/([^/]+)$/, rows: mockupJobs, entity: 'AI 시안 작업', back: '/ai/mockups' },
  { pattern: /^\/content\/moderation\/([^/]+)$/, rows: moderationCases, entity: '사후관리 콘텐츠', back: '/content/moderation' },
]

export function findMissingDetailEntity(route) {
  for (const rule of RULES) {
    const match = route.match(rule.pattern)
    if (!match) continue
    const id = match[1]
    if (!rule.rows.some((row) => row.id === id)) {
      return { entity: rule.entity, id, back: rule.back }
    }
    return null
  }
  return null
}
